export default __webpack_public_path__ + "static/media/customdev.fdb4ab12.png";